export default class BillingProduct {
  public id: string;
  public name: string;
  public description: string;
  public billingProvider: string;
  public externalId: string;
  public editable: boolean;

  constructor(options) {
    this.id = options.id;
    this.name = options.name;
    this.description = options.description;
    this.billingProvider = options.billingProvider;
    this.externalId = options.externalId;
    this.editable = options.editable;
  }
}
